import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function oldNewPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const oldPassword = control.get('oldPassword')?.value;
        const newPassword = control.get('newPassword')?.value;
        const newPasswordControl = control.get('newPassword');

        if (oldPassword && newPassword && oldPassword === newPassword) {
            newPasswordControl?.setErrors({ samePassword: true });
            return { samePassword: true };
        }
        if (newPasswordControl?.hasError('samePassword')) {
            const errors = { ...newPasswordControl.errors };
            delete errors['samePassword'];
            newPasswordControl.setErrors(Object.keys(errors).length ? errors : null);
        }

        return null;
    };
}